import React from 'react'
import { TfiArrowTopRight } from "react-icons/tfi";

const Button = ({ text, variant = "default" }) => {
  const baseStyles = "px-10 py-4 rounded-[6rem] shadow-inset shadow-[rgba(255, 255, 255, 0.28)] flex items-center gap-2 transition-colors duration-300";
  const variants = {
    default: "bg-[#A2BC6B] text-black hover:bg-[#8da65b]",
    neutral: "bg-neutral-800 text-white hover:bg-neutral-700 border border-neutral-700"
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]}`}
      aria-label={text || "Open link"}
    >
      {text && <span>{text}</span>}
      <TfiArrowTopRight />
    </button>
  )
}

export default Button
